<template>
    <div class="container justify-content-center">
        <div class="row mt-5 text-center justify-content-center">
            <div class="col-12 mt-5 col-lg-6">
                <img src="img/brand/pandas/conspiracy.png"  class="mt-5 img-fluid">
                <h3>404 Not Found</h3>
                <h5>Looks like your search brought you to a dead end</h5>

                <!--<img v-lazy="'img/brand/pandas/hero.png'" class="rounded-circle">-->

            </div>
        </div>
        <div class="row text-center justify-content-center">
            <div class="col-12 col-lg-5 col-md-7 col-sm-9">
                <div class="row">
                    <div class="col-12 mt-3 col-lg-6 col-md-6 col-sm-6">
                        <base-button tag="a"
                                     href="https://offthecouchgames.com"
                                     type="warning">
                            Get me out of here
                        </base-button>
                    </div>
                    <div class="col-12 mt-3 col-lg-5 col-md-6 col-sm-6">
                        <base-button tag="a"
                                     href="https://offthecouchgames.com/contact"
                                     type="primary">
                            Ask for a clue
                        </base-button>
                    </div>
                </div>


            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped>

</style>
